import CONFIGS from "../configs";


const paymentSchema = (data, type) => {
    try {

        let transactionData = {
            "Amount": parseFloat(data.amount.trim().replace(/,/g, '')),
            "MerchantID": data.merchantId.trim(),
            "TransactionKey": data.transactionKey.trim(),
            "TransactionType": "SALE"
        }

        if (CONFIGS.MODE !== 'production') {
            transactionData = { ...transactionData, "TestRequest": true };
        }


        //address data:
        transactionData = {
            ...transactionData,
            "Street": data.address2 === '' ? `${data.address1}`.trim() : `${data.address1},${data.address2}`.trim(),
            "Zip": data.postalCode.trim(),
            "Country": data.country.trim(),
        }

        if(data.invoiceNumber.trim() !== ''){
            transactionData = { ...transactionData, 'CustomValue1': data.invoiceNumber.trim() };
        }
        if(data.poNumber.trim() !== ''){
            transactionData = { ...transactionData, 'CustomValue2': data.poNumber.trim() };
        }
        if(data.description.trim() !== ''){
            transactionData = { ...transactionData, 'CustomValue3': data.description.trim() };
        }
        if (data.city.trim() !== '') {
            transactionData = { ...transactionData, 'City': data.city.trim() };
        }
        if (data.state.trim() !== '') {
            transactionData = { ...transactionData, 'State': data.state.trim() };
        }

        //email data:
        transactionData = {
            ...transactionData,
            "Email" : data.email.trim(),
            "MerchantReceipt" : true,
            "CardHolderReceipt" : true
        }
        
        let emailList = data.receiptEmails ? data.receiptEmails.split(",") : [];
        if(emailList && emailList.length > 0 ){
            transactionData = {
                ...transactionData,
                "ReceiptCopyEmailAddresses" : emailList.map((item)=>{ return item.trim() }).join(',')
            }
        }

        //card data:
        if (type === 'card') {
            transactionData = {
                ...transactionData,
                "CardName": data.nameOnCard.trim(),
                "CardType": data.cardType.trim(),
                "CardNumber": data.cardNumber.replace(/\s+/g, ''),
                "ExpirationDate": data.expirationDate.replace(/\//g, ''),
                "CVV2": data.cvv.trim(),
                "Phone": data.mobileNo.replace(/\D/g, '')
            };

            if(data.is3DSecure){
                transactionData = {
                    ...transactionData,
                    "CAVV" : data.cavv.trim(),
                    "DirectoryServerTransactionId" :  data.threeDSServerTransactionId.trim(),
                    "ECI" : data.eciFlag.trim(),
                    "IsAddDSRPValue": 0
                }

                if(data?.xid){
                    transactionData = {...transactionData,"XID" : data.xid.trim()};
                }
            }
        }

        //echeck data:
        if (type === 'eCheck') {
            transactionData = {
                ...transactionData,
                "IsAchTransaction": true,
                "ECheckType" : "WEB",
                "AccountNumber": data.accountNumber.trim(),
                "RoutingNumber": data.routingNumber.trim(),
                "AccountType": data.accountType.trim(),
                "BankAccountType": data.bankAccountType.trim(),
                "NameOnAccount": data.bankAccountType.trim() !== 'Personal' ? data.businessName.trim() : `${data.firstName} ${data.lastName}`.trim(),
            };
        }        

        return transactionData;
    } catch (error) {
        throw error;
    }
}

export default paymentSchema;